import { inject, injectable } from "@launchtray/tsyringe-async";
import { Event } from "event-system";
import { IGameDistributionSdk } from "./interfaces/IGameDistributionSdk";
import { AdSceneFactory, InjectableFactories } from "../composition/InjectableFactories";
import { SceneManager } from "scene-manager";

@injectable()
export class DummySdkWrapper implements IGameDistributionSdk {
    public readonly pauseAudio: Event;
    public readonly resumeAudio: Event;

    public constructor(
        private readonly sceneManager: SceneManager,
        @inject(InjectableFactories.AdSceneFactory) private readonly adSceneFactory: AdSceneFactory
    ) {
        this.pauseAudio = new Event();
        this.resumeAudio = new Event();
    }

    public async initialize(): Promise<void> {
    }

    public async showRewardedAd(): Promise<boolean> {
        this.adGamePause();
        const adScene = await this.adSceneFactory();
        const result = await this.sceneManager.showViewableAsync(adScene);
        console.log("Rewarded ad finished");
        this.adGameStart();
        return result;
    }

    public async showMidrollAd(): Promise<void> {
        this.adGamePause();
        const adScene = await this.adSceneFactory();
        const _result = await this.sceneManager.showViewableAsync(adScene);
        console.log("Midroll ad finished");
        this.adGameStart();
    }

    private adGamePause(): void {
        this.pauseAudio.emit();
    }

    private adGameStart(): void {
        this.resumeAudio.emit();
    }

}
